
import useYMHit from "./useYMHit";

export default function RouteChangeTracker() {
  useYMHit();
  return null;
}
